if (document.getElementById('vue-home')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin ],
		el: '#vue-home',
		data: {
			residences: [],
			articles: [],
            selectedCategory: '',
		},
		created() {
			this.$validator.localize('fr');
		},
		mounted() {
			this.getResidences();
            if (window.site_id === 2) {
                this.selectedCategory = 4;
            }
			this.getArticles();
		},
		methods: {
			getResidences() {
				this.get('residences', { site: window.site_id }, false)
					.then((response) => {
						this.residences = response.data.results;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			getArticles() {
				this.get('articles', { category__sites: window.site_id, block_display: true, category: this.selectedCategory }, false)
					.then((response) => {
						this.articles = response.data.results;
						this.$nextTick(() => {
							initCarouselNews();
						});
					})
					.catch((error) => {
						// console.log(error);
					});
			}
		}
	});
}
